"use client";
import { createContext } from "react";
//#region packages/@mantine/core/src/components/Input/InputWrapper.context.ts
const InputWrapperContext = createContext({
	offsetBottom: false,
	offsetTop: false,
	describedBy: void 0,
	getStyles: null,
	inputId: void 0,
	labelId: void 0
});
//#endregion
export { InputWrapperContext };

//# sourceMappingURL=InputWrapper.context.mjs.map